module.exports = __webpack_public_path__ + "img/图层601.0bff9979.png";